import { useMutation } from "@apollo/client/react";
import { DELETE_INVOICE_UPLOAD_DOCUMENT } from "../../mutations/documentHandler/deleteInvoiceUploadDocument";
import GET_ALL_UPLOAD_UNITS from "../../queries/documentHandler/getAllUploadUnits";
import GET_CLIENTS_WITH_UPLOAD_UNITS from "../../queries/documentHandler/getClientsWithUploadUnits";

export const useDeleteInvoiceUploadDocument = ({
  onCompleted,
  onError,
}: {
  onCompleted: (data: any) => void;
  onError: (error: any) => void;
}) => {
  const [deleteInvoiceUploadDocument, { data, loading, error }] = useMutation(
    DELETE_INVOICE_UPLOAD_DOCUMENT,
    {
      onCompleted: onCompleted,
      onError: onError,
      refetchQueries: [GET_ALL_UPLOAD_UNITS, GET_CLIENTS_WITH_UPLOAD_UNITS],
      awaitRefetchQueries: true,
    },
  );

  return { deleteInvoiceUploadDocument, data, loading, error };
};
